module.exports = __webpack_public_path__ + "img/25_7.79b95dad.png";